module.exports = __webpack_public_path__ + "img/message.f00e5313.svg";